var map = {
	"./food.png": 3995,
	"./group.png": 8414,
	"./home.png": 9090,
	"./logout.png": 3525,
	"./megaphone.png": 3989,
	"./money.png": 8411,
	"./tag.png": 2999,
	"./user.png": 6798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4071;